import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import SiteClosed from "@/components/SiteClosed";

// ─── SITE TEMPORARILY CLOSED ──────────────────────────────────────────────
// The full app is replaced by a static holding page so nobody can access the
// site. TO RESTORE THE SITE: set SITE_OPEN back to true (renders <App />).
const SITE_OPEN = false;
// ──────────────────────────────────────────────────────────────────────────

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    environment: window.location.hostname.includes('preview.emergentagent') ? 'preview' : 'production',
    ignoreErrors: [
      'this.o.at is not a function', // web-vitals bug in Safari/older browsers
      'Non-Error promise rejection captured', // benign browser noise
    ],
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#faf8f5', fontFamily: 'Outfit, sans-serif', padding: '24px', textAlign: 'center' }}>
        <p style={{ fontSize: '20px', color: '#2a2725', marginBottom: '8px', fontWeight: 600 }}>Something went wrong</p>
        <p style={{ fontSize: '14px', color: '#8c8782', marginBottom: '24px' }}>Iris hit an unexpected snag. Try refreshing the page.</p>
        <button onClick={() => window.location.reload()} style={{ padding: '12px 32px', background: '#C9A84C', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' }}>Refresh Page</button>
      </div>
    }>
      {SITE_OPEN ? <App /> : <SiteClosed />}
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
